<template>
    <div class="matchmaker relative pb-px w-screen">
        <div ref="container" class="min-h-svh">
            <div ref="content" class="matchmaker__content relative min-h-svh flex flex-col w-full overflow-x-hidden">
                <div
                    :class="{
                        'md:max-w-[1200px]': currentStepId === 'results',
                        'md:max-w-[1128px]': currentStepId !== 'results',
                    }"
                    class="matchmaker__content-container relative w-full max-w-[450px] mx-auto px-6 h-auto min-h-svh flex flex-col"
                >
                    <header ref="header" class="matchmaker__header relative h-svh flex flex-col justify-center items-center text-center max-w-full md:max-w-[645px] mx-auto">
                        <div class="absolute flex flex-row left-1/2 top-8 transform -translate-x-1/2 md:top-12">
                            <img ref="logoAldi" src="~@/static/images/logo-aldi.svg" alt="logo ALDI" class="matchmaker__aldi-logo w-10 md:w-16" />
                            <div ref="logoExpMobile" class="w-0 overflow-hidden flex-shrink-0">
                                <img src="~@/static/images/logo-exp.svg" alt="L'assistant sommelier" class="max-w-none h-[48px] md:hidden" />
                            </div>
                        </div>
                        <div ref="introLogos" class="flex flex-col items-center gap-4 md:gap-6">
                            <div ref="imgIntro" class="overflow-hidden flex-shrink-0">
                                <img src="~@/static/images/intro.svg" alt="logo intro" class="w-[66px] md:w-[80px]" aria-hidden="true" aria-label="test" />
                            </div>
                            <img ref="logoExp" src="~@/static/images/logo-exp.svg" alt="L'assistant sommelier" class="matchmaker__exp-logo w-auto h-[64px] md:h-[84px] flex-shrink min-w-0" />
                        </div>
                        <div ref="part1" class="overflow-hidden">
                            <div ref="part1Inner" class="flex flex-col justify-center items-center">
                                <p ref="introText" class="lead text-white mt-6 md:mt-8" v-html="translations.intro.text"></p>
                                <p ref="introText2" class="body-2 text-white mt-6">
                                    {{ translations.intro.text2 }}
                                </p>
                                <button ref="introBtn" class="relative btn btn--plain-white btn--M mt-6 md:mt-8 z-10" @click="endIntro">
                                    {{ translations.intro.startButton }}
                                </button>
                            </div>
                        </div>
                        <div ref="progress" class="matchmaker__progress-bar flex w-full justify-center items-center h-0 opacity-0 overflow-hidden flex-shrink-0 mx-auto">
                            <progress-bar :max="maxStep" :current="currentStepCount"></progress-bar>
                        </div>
                    </header>
                    <div v-if="currentStepId !== 'intro'" ref="currentStep" class="matchmaker__current-step flex-grow mt-5 md:mt-8 pb-[152px]">
                        <component v-if="currentStep && currentStep.type" :is="currentStep.type" :data="currentStep" :products="matchProducts" :translations="translations" :wine-color="currentWineColor" :meal="currentMeal" @end-step="updateStep" @restart="restart"></component>
                    </div>
                    <div ref="bottomUtils" class="w-full absolute bottom-0 left-0 right-0 flex justify-center items-start h-[158px] md:h-8 transition-all duration-500 justify-self-end">
                        <div class="matchmaker__intro-block-1 flex flex-row items-end absolute bottom-4 md:bottom-0 left-1/2 -translate-x-1/2 md:-translate-x-full md:-ml-[300px] scale-[0.8] md:scale-100 overflow-hidden w-[450px]">
                            <img ref="introAsset1" src="~@/static/images/intro/intro-asset-1.svg" alt="Illustration de bouteille" aria-hidden="true" class="transform translate-y-full -mb-3" />
                            <img ref="introAsset2" src="~@/static/images/intro/intro-asset-2.svg" alt="Illustration de bouteille" aria-hidden="true" class="transform translate-y-full -mb-3" />
                            <img ref="introAsset3" src="~@/static/images/intro/intro-asset-3.svg" alt="Illustration de verre" aria-hidden="true" class="transform translate-y-full -mb-3 ml-8" />
                        </div>
                        <div class="matchmaker__intro-block-2 hidden md:flex items-end absolute bottom-0 left-1/2 ml-[300px] overflow-hidden w-[388px]">
                            <img ref="introAsset4" src="~@/static/images/intro/intro-asset-4.svg" alt="Illustration de bouteille" aria-hidden="true" class="transform translate-y-full -mb-3" />
                            <img ref="introAsset5" src="~@/static/images/intro/intro-asset-5.svg" alt="Illustration de verre" aria-hidden="true" class="transform translate-y-full -mb-3 ml-12" />
                            <img ref="introAsset6" src="~@/static/images/intro/intro-asset-6.svg" alt="Illustration de bouteille" aria-hidden="true" class="transform translate-y-full -mb-3 ml-12" />
                        </div>
                        <div ref="backBtnMobile" class="items-center h-[50px] hidden opacity-0 absolute bottom-12 left-1/2 -translate-x-1/2">
                            <button class="btn-text btn-text--back" @click="back">
                                {{ translations.common.back }}
                            </button>
                        </div>

                        <p v-if="currentStepId === 'results'" class="body-4 text-white absolute bottom-14 left-1/2 -translate-x-1/2 whitespace-no-wrap w-full text-center">Sous réserve de disponibilité en magasin</p>
                        <div class="matchmaker__legal-warning flex flex-row justify-center items-center gap-x-1 absolute bottom-1 md:bottom-4 left-0 right-0">
                            <img src="~@/static/images/icons/abus.png" alt="Attention abus" class="w-6 h-6" />
                            <p class="body-4 text-white">L'abus d'alcool est dangereux pour la santé</p>
                        </div>
                    </div>
                </div>
            </div>
            <div ref="backBtnDesk" class="back-button hidden absolute top-12 left-12 opacity-0 z-10">
                <button class="btn btn--S btn--ghost-white btn--back" @click="back">
                    {{ translations.common.back }}
                </button>
            </div>
            <div ref="restartButton" class="restart-button absolute bottom-32 md:bottom-auto md:top-12 left-1/2 md:left-12 transform -translate-x-1/2 md:translate-x-0 opacity-0 hidden z-10">
                <button v-if="translations" class="btn btn--M btn--ghost-white btn--restart whitespace-nowrap" @click="restart">
                    {{ translations.common.restart }}
                </button>
            </div>
        </div>
        <LegalPopin :translations="translations"></LegalPopin>
    </div>
</template>

<script>
    import gsap from 'gsap';
    import MatchmakerResults from '@/app/components/MatchmakerResults.vue';
    import ChoiceCard from '@/app/components/ChoiceCard.vue';
    import MatchmakerSingleChoiceStep from '@/app/components/MatchmakerSingleChoiceStep.vue';
    import ProgressBar from '@/app/components/ProgressBar.vue';
    import LegalPopin from '@/app/components/LegalPopin.vue';
    import tree from '../steps.json';

    export default {
        name: 'Matchmaker',

        components: {
            MatchmakerResults,
            ChoiceCard,
            MatchmakerSingleChoiceStep,
            ProgressBar,
            LegalPopin,
        },

        props: {
            translations: { type: Object, default: () => {}, required: true },
            products: { type: Array, default: () => [], required: true },
        },

        data: () => ({
            choices: [],
            history: [],
            currentStepId: 'intro',
            currentStepCount: 1,
            maxStep: 3,
            currentProductIndex: 0,
            breakpoint: 768,
            device: 'mobile',
            test: 0,
            currentWineColor: '',
            currentMeal: '',
        }),

        computed: {
            currentStep() {
                return tree.steps.filter((step) => step.id === this.currentStepId)[0];
            },

            matchProducts() {
                const products = JSON.parse(JSON.stringify(this.products));

                // Parcours C : "surprise"
                if (this.choices.length === 1 && this.choices[0].go === 'results') {
                    const shuffled = products.sort(() => 0.5 - Math.random());
                    return shuffled.slice(0, 3);
                }

                const colorChoice = this.choices.find((c) => c.map === 'color' && c.value);
                const mealChoice = this.choices.find((c) => c.map === 'meal' && c.value);
                const flavorChoice = this.choices.find((c) => c.map === 'flavor' && c.value);

                // 🔴 1. HARD FILTERS (obligatoires)
                let filtered = products.filter((product) => {
                    if (colorChoice) {
                        if (!product.color || product.color.value?.toLowerCase() !== colorChoice.value?.toLowerCase()) {
                            return false;
                        }
                    }
                    if (mealChoice) {
                        console.log(product);
                        if (!product.dishes || Object.keys(product.dishes).length === 0 || !product.dishes.some((d) => d.value === mealChoice.value)) {
                            return false;
                        }
                    }
                    return true;
                });

                // 🟡 2. SOFT FILTER (optionnel)
                if (flavorChoice && filtered.length > 0) {
                    const flavorMatched = filtered.filter((product) => product.flavor && product.flavor.value?.toLowerCase() === flavorChoice.value?.toLowerCase());
                    if (flavorMatched.length > 0) {
                        filtered = flavorMatched;
                    }
                }

                // 🎲 3. LIMIT à 3 résultats avec boost `mea`
                if (filtered.length > 3) {
                    const meaProducts = filtered.filter((p) => p.mea === true).sort(() => 0.5 - Math.random());
                    const otherProducts = filtered.filter((p) => p.mea !== true).sort(() => 0.5 - Math.random());
                    return [...meaProducts, ...otherProducts].slice(0, 3);
                }

                // 🧯 4. FALLBACKS (mais SANS casser color/meal)
                if (filtered.length === 0) {
                    if (colorChoice) {
                        const colorProducts = products.filter((p) => p.color && p.color.value?.toLowerCase() === colorChoice.value?.toLowerCase());
                        if (colorProducts.length > 0) {
                            const mea = colorProducts.filter((p) => p.mea === true).sort(() => 0.5 - Math.random());
                            const others = colorProducts.filter((p) => p.mea !== true).sort(() => 0.5 - Math.random());
                            return [...mea, ...others].slice(0, 3);
                        }
                    }

                    if (mealChoice) {
                        const mealProducts = products.filter((p) => p.dishes && p.dishes.some((d) => d.value === mealChoice.value));
                        if (mealProducts.length > 0) {
                            const mea = mealProducts.filter((p) => p.mea === true).sort(() => 0.5 - Math.random());
                            const others = mealProducts.filter((p) => p.mea !== true).sort(() => 0.5 - Math.random());
                            return [...mea, ...others].slice(0, 3);
                        }
                    }

                    // dernier recours
                    const mea = products.filter((p) => p.mea === true).sort(() => 0.5 - Math.random());
                    const others = products.filter((p) => p.mea !== true).sort(() => 0.5 - Math.random());
                    return [...mea, ...others].slice(0, 3);
                }

                return filtered;
            },
        },

        mounted() {
            window.dataLayer.push({
                event: 'assistant_sommelier_etape',
                numero_etape: 0,
                nom_etape: 'accueil',
                choix: null,
            });

            // Begin with the introduction
            this.showIntro();

            this.resizeHandler();

            window.addEventListener('resize', this.resizeHandler);
        },

        methods: {
            updateStep(choice) {
                // Save current step into history
                this.history.push(this.currentStep);

                // Add the choice
                this.choices.push(choice);

                if (choice.go !== 'results') {
                    // Increase step count
                    this.currentStepCount++;
                } else {
                    this.goToResults();
                }

                // console.log(this.choices);
                //
                const color = this.choices.find((c) => c.map === 'color');
                const meal = this.choices.find((c) => c.map === 'meal');
                if (color) {
                    this.currentWineColor = color.value !== '' ? this.translations[color.label].toLowerCase() : '';
                } else if (meal) {
                    this.currentMeal = meal.value !== '' ? this.translations[meal.label].toLowerCase() : '';
                }

                // Update the current id with the new one
                this.currentStepId = choice.go;
            },

            back() {
                if (this.endTL) {
                    this.endTL.kill();
                    this.endTL = null;
                }

                this.history = JSON.parse(JSON.stringify(this.history));

                // If we have something in the history
                if (this.history.length > 0) {
                    // Remove last choice
                    this.choices = this.choices.slice(0, -1);

                    // Update the current step id with the last one in history
                    this.currentStepId = this.history[this.history.length - 1].id;

                    // Remove last from history
                    this.history = this.history.slice(0, -1);

                    // Count of step -1
                    this.currentStepCount = Math.max(this.history.length + 1, 0);

                    this.placeOnBack();
                } else {
                    // Reset choices
                    this.choices = [];

                    // Reset current step id
                    this.currentStepId = 'intro';

                    // Reset
                    this.$nextTick(() => {
                        this.reset();
                    });
                }
            },

            restart() {
                window.dataLayer.push({
                    event: 'assistant_sommelier_interaction',
                    action: 'restart_quiz',
                    nom_etape: 'page_resultats',
                    item_name: null,
                });

                // Reset
                this.choices = [];
                this.history = [];
                this.currentStepCount = 1;

                this.currentStepId = tree.steps[0].go;

                // Update the container
                gsap.to(
                    this.$refs.container,
                    {
                        height: window.innerHeight,
                        duration: 0.6,
                        ease: 'power1.out',
                    },
                    0,
                );

                gsap.to(
                    this.$refs.progress,
                    {
                        height: 23,
                        marginTop: window.innerWidth < 768 ? 64 : 48,
                        duration: 0.3,
                        ease: 'power2.out',
                    },
                    0,
                );

                gsap.to(
                    this.$refs.header,
                    {
                        height: window.innerWidth < 768 ? 143 : 273,
                        paddingTop: window.innerWidth < 768 ? 32 : 115,
                        duration: 0.3,
                        ease: 'power2.out',
                    },
                    0,
                );

                // Update the content
                gsap.to(
                    this.$refs.content,
                    {
                        paddingBottom: 0,
                        duration: 0.6,
                        ease: 'power1.out',
                    },
                    0,
                );

                gsap.to(
                    this.$refs.currentStep,
                    {
                        paddingBottom: 158,
                        duration: 0.6,
                        ease: 'power1.out',
                    },
                    0,
                );

                if (window.innerWidth < 768) {
                    // Hide back button
                    gsap.to(this.$refs.backBtnMobile, {
                        opacity: 1,
                        display: 'block',
                        duration: 0.4,
                    });
                } else {
                    // Hide back button
                    gsap.to(this.$refs.backBtnDesk, {
                        opacity: 1,
                        display: 'block',
                        duration: 0.4,
                    });
                }

                gsap.to(document.querySelector('.restart-button'), {
                    opacity: 0,
                    display: 'none',
                    duration: 0.4,
                });
            },

            reset() {
                this.resetTL = gsap.timeline({});
                const backBtn = window.innerWidth < 768 ? this.$refs.backBtnMobile : this.$refs.backBtnDesk;

                this.resetTL.to(backBtn, {
                    opacity: 0,
                    display: 'none',
                    duration: 0.4,
                    ease: 'power1.out',
                });

                this.resetTL.to(
                    this.$refs.progress,
                    {
                        opacity: 0,
                        height: 0,
                        duration: 0.4,
                        ease: 'power1.out',
                    },
                    0,
                );

                this.resetTL.to(
                    this.$refs.header,
                    {
                        height: window.innerHeight,
                        paddingTop: 0,
                        duration: 0.8,
                        ease: 'power2.out',
                    },
                    0.4,
                );

                this.resetTL.to(
                    this.$refs.logoExp,
                    {
                        height: window.innerWidth < 768 ? 64 : 84,
                        duration: 0.8,
                        ease: 'power2.out',
                    },
                    0.4,
                );

                this.resetTL.to(
                    this.$refs.imgIntro,
                    {
                        height: 100,
                        duration: 0.8,
                        ease: 'power2.out',
                    },
                    0.4,
                );

                this.resetTL.to(
                    this.$refs.part1,
                    {
                        height: this.$refs.part1Inner.clientHeight + 50,
                        paddingBottom: 50,
                        duration: 0.6,
                        ease: 'power2.out',
                    },
                    0.4,
                );

                this.resetTL
                    .fromTo(
                        [this.$refs.imgIntro, this.$refs.introText, this.$refs.introText2, this.$refs.introBtn],
                        {
                            y: -20,
                            opacity: 0,
                        },
                        {
                            y: 0,
                            opacity: 1,
                            stagger: 0.1,
                            duration: 0.8,
                            ease: 'power1.out',
                        },
                        0.6,
                    )
                    .then(this.introAssetAnim);

                if (window.innerWidth < 768) {
                    this.resetTL.to(
                        [this.$refs.logoExp],
                        {
                            opacity: 1,
                            duration: 0.4,
                            ease: 'power1.out',
                        },
                        0.6,
                    );

                    this.resetTL.to(
                        this.$refs.logoExpMobile,
                        {
                            width: 0,
                            marginLeft: 0,
                            duration: 0.4,
                            ease: 'power1.out',
                        },
                        0.4,
                    );

                    this.resetTL.to(
                        this.$refs.introLogos,
                        {
                            height: 180,
                            duration: 0.6,
                            ease: 'power2.out',
                        },
                        0.4,
                    );
                }
            },

            goToResults() {
                if (window.innerWidth < 768) {
                    // Hide back button
                    gsap.to(this.$refs.backBtnMobile, {
                        opacity: 0,
                        display: 'none',
                        duration: 0.4,
                    });
                } else {
                    // Hide back button
                    gsap.to(this.$refs.backBtnDesk, {
                        opacity: 0,
                        display: 'none',
                        duration: 0.4,
                    });
                }

                // Hide the unecessary components
                gsap.to([this.$refs.progress], {
                    height: 0,
                    marginTop: 0,
                    duration: 0.3,
                    ease: 'power2.out',
                });

                gsap.to([this.$refs.currentStep], {
                    paddingBottom: 242,
                    marginTop: 0,
                    duration: 0.3,
                    ease: 'power2.out',
                });

                gsap.to(this.$refs.header, {
                    height: window.innerWidth < 768 ? 170 : 263,
                    paddingTop: window.innerWidth < 768 ? 100 : 52,
                    duration: 0.3,
                    ease: 'power2.out',
                });

                // Update the container
                gsap.to(this.$refs.container, {
                    padding: 0,
                    height: 'auto',
                    duration: 0.6,
                    ease: 'power1.out',
                });
            },

            placeOnBack() {
                // // Hide the unecessary components
                // gsap.to(this.$refs.bottomUtils, {
                //     height: 112,
                //     duration: 0.3,
                //     ease: 'power2.out'
                // });
                //
                // gsap.to(this.$refs.header, {
                //     height: window.innerWidth < 768 ? Math.min(window.innerHeight*30/100, 250) : window.innerHeight < 700 ? 267 : 337,
                //     paddingTop: window.innerWidth < 768 ? 39 : 52,
                //     duration: 0.6,
                //     ease: 'power2.out',
                // });
                //
                // // Update the container
                // gsap.to(this.$refs.container, {
                //     height: window.innerHeight,
                //     duration: 0.6,
                //     ease: 'power1.out'
                // });
                //
                // // Update the content
                // // gsap.to(this.$refs.content, {
                // //     paddingBottom: 0,
                // //     duration: 0.6,
                // //     ease: 'power1.out'
                // // });
                //
                // gsap.to(this.$refs.currentStep, {
                //     paddingBottom: 112,
                //     duration: 0.6,
                //     ease: 'power1.out'
                // })
                //
                // gsap.to(this.$refs.headerPlacer, {
                //     height: Math.min(window.innerHeight*30/100, 250) - this.$refs.logoExp.clientHeight - 22 - 24,
                //     duration: 0.6,
                //     ease: 'power2.out'
                // }, 0.6);
                //
                //
                // gsap.to(this.$refs.progress, {
                //     height: 22,
                //     marginTop: window.innerWidth < 768 ? 24 : (window.innerHeight < 700) ? 50 : 112,
                //     opacity: 1,
                //     duration: 0.6
                // }, 0.6);
                //
                //
                // const backBtn = window.innerWidth < 768 ? this.$refs.backBtnMobile : this.$refs.backBtnDesk;
                // gsap.to(backBtn, {
                //     opacity: 1,
                //     display: 'inline-flex',
                //     duration: 0.6,
                //     ease: 'power2.out'
                // }, 1.2);
            },

            // Show the part 1 of the intro
            showIntro() {
                // Init intro tl
                this.introTL = gsap.timeline({
                    delay: 0.5,
                });

                // Show the content
                this.introTL
                    .fromTo(
                        [this.$refs.imgIntro, this.$refs.logoExp, this.$refs.introText, this.$refs.introText2, this.$refs.introBtn],
                        {
                            y: -20,
                            opacity: 0,
                        },
                        {
                            y: 0,
                            opacity: 1,
                            stagger: 0.1,
                            duration: 0.8,
                            ease: 'power1.out',
                        },
                    )
                    .then(this.introAssetAnim);
            },

            // Hide entirely the intro
            endIntro() {
                window.dataLayer.push({
                    event: 'assistant_sommelier_interaction',
                    action: 'demarrer_quiz',
                    nom_etape: 'accueil',
                    item_name: null,
                });

                const backBtn = window.innerWidth < 768 ? this.$refs.backBtnMobile : this.$refs.backBtnDesk;

                this.endTL = gsap.timeline({
                    onComplete: () => {
                        // On the end, we go to the next step
                        this.currentStepId = this.currentStep.go;
                    },
                });

                // Hide part 2 text and co
                this.endTL.to(
                    [this.$refs.imgIntro, this.$refs.introText, this.$refs.introText2, this.$refs.introBtn],
                    {
                        opacity: 0,
                        duration: 0.6,
                        ease: 'power2.out',
                    },
                    0,
                );

                this.endTL
                    .to(
                        [this.$refs.introAsset1, this.$refs.introAsset3, this.$refs.introAsset2, this.$refs.introAsset6, this.$refs.introAsset4, this.$refs.introAsset5],
                        {
                            y: '100%',
                            display: 'none',
                            stagger: 0.03,
                            duration: 0.3,
                            ease: 'power3.out',
                        },
                        0.6,
                    )
                    .then(this.stopFloating);

                if (window.innerWidth < 768) {
                    this.endTL.to(
                        [this.$refs.logoExp],
                        {
                            opacity: 0,
                            duration: 0.6,
                            ease: 'power2.out',
                        },
                        0,
                    );

                    this.endTL.to(
                        this.$refs.logoExpMobile,
                        {
                            width: this.$refs.logoExpMobile.querySelector('img').clientWidth,
                            marginLeft: 16,
                            duration: 0.4,
                            ease: 'power1.out',
                        },
                        0.6,
                    );

                    this.endTL.to(
                        [this.$refs.logoExp],
                        {
                            height: 0,
                            duration: 0.6,
                            ease: 'power2.out',
                        },
                        0.4,
                    );
                    this.endTL.to(
                        [this.$refs.introLogos],
                        {
                            height: 0,
                            duration: 0.6,
                            ease: 'power2.out',
                        },
                        0.4,
                    );
                }

                this.endTL.to(
                    this.$refs.header,
                    {
                        height: window.innerWidth < 768 ? 143 : 273,
                        paddingTop: window.innerWidth < 768 ? 32 : 115,
                        duration: 0.6,
                        ease: 'power2.out',
                    },
                    0.4,
                );

                this.endTL.to(
                    [this.$refs.imgIntro],
                    {
                        height: 0,
                        duration: 0.6,
                        ease: 'power2.out',
                    },
                    0.4,
                );

                this.endTL.to(
                    this.$refs.part1,
                    {
                        height: 0,
                        paddingBottom: 0,
                        duration: 0.6,
                        ease: 'power2.out',
                    },
                    0.4,
                );

                this.endTL.to(
                    this.$refs.logoExp,
                    {
                        height: window.innerWidth < 768 ? 48 : 64,
                        duration: 0.6,
                        ease: 'popwer2.out',
                    },
                    0.4,
                );

                this.endTL.to(
                    this.$refs.progress,
                    {
                        height: 23,
                        marginTop: window.innerWidth < 768 ? 64 : 48,
                        duration: 0.6,
                    },
                    0.4,
                );

                this.endTL.to(
                    this.$refs.progress,
                    {
                        opacity: 1,
                        duration: 0.6,
                        ease: 'power2.out',
                    },
                    0.9,
                );

                this.endTL.to(
                    backBtn,
                    {
                        opacity: 1,
                        display: 'inline-flex',
                        duration: 0.6,
                        ease: 'power2.out',
                    },
                    1,
                );
            },

            introAssetAnim() {
                this.introAssetTL = gsap.timeline({});

                const allAssets = [this.$refs.introAsset1, this.$refs.introAsset2, this.$refs.introAsset3, this.$refs.introAsset4, this.$refs.introAsset5, this.$refs.introAsset6].filter(Boolean);

                // Nettoyer tous les styles inline résiduels de GSAP
                gsap.set(allAssets, { clearProps: 'all' });
                // Remettre en position cachée
                gsap.set(allAssets, { y: '100%' });

                this.introAssetTL.fromTo(
                    [this.$refs.introAsset1, this.$refs.introAsset3, this.$refs.introAsset2],
                    {
                        y: '100%',
                    },
                    {
                        y: 0,
                        stagger: 0.05,
                        duration: 0.4,
                        ease: 'power3.out',
                    },
                    0.1,
                );

                // Animate intro bottles (block 2 - right side, desktop only)
                this.introAssetTL.fromTo(
                    [this.$refs.introAsset5, this.$refs.introAsset4, this.$refs.introAsset6],
                    {
                        y: '100%',
                    },
                    {
                        y: 0,
                        stagger: 0.05,
                        duration: 0.4,
                        ease: 'power3.out',
                    },
                    0.2,
                );

                // Once entry animation is done, start the floating effect
                this.introAssetTL.call(() => {
                    this.startFloating();
                });
            },

            startFloating() {
                const assets = [this.$refs.introAsset1, this.$refs.introAsset2, this.$refs.introAsset3, this.$refs.introAsset4, this.$refs.introAsset5, this.$refs.introAsset6];

                // Différentes configs pour chaque élément pour un effet organique
                const configs = [
                    { yAmp: 6, rot: 2, duration: 2.8, delay: 0 },
                    { yAmp: 8, rot: -2.5, duration: 3.2, delay: 0.3 },
                    { yAmp: 5, rot: 1.5, duration: 2.5, delay: 0.6 },
                    { yAmp: 7, rot: -2, duration: 3.0, delay: 0.2 },
                    { yAmp: 6, rot: 2.5, duration: 2.6, delay: 0.5 },
                    { yAmp: 9, rot: -1.5, duration: 3.4, delay: 0.1 },
                ];

                this.floatingTweens = [];

                assets.forEach((asset, i) => {
                    if (!asset) return;

                    const cfg = configs[i];

                    // Mouvement vertical (haut/bas)
                    const tweenY = gsap.to(asset, {
                        y: -cfg.yAmp,
                        duration: cfg.duration,
                        delay: cfg.delay,
                        ease: 'sine.inOut',
                        yoyo: true,
                        repeat: -1,
                    });

                    // Rotation (droite/gauche)
                    const tweenRot = gsap.to(asset, {
                        rotation: cfg.rot,
                        duration: cfg.duration * 1.2,
                        delay: cfg.delay + 0.2,
                        ease: 'sine.inOut',
                        yoyo: true,
                        repeat: -1,
                    });

                    this.floatingTweens.push(tweenY, tweenRot);
                });
            },

            stopFloating() {
                if (this.floatingTweens) {
                    this.floatingTweens.forEach((tween) => tween.kill());
                    this.floatingTweens = null;
                }
            },

            resizeHandler() {
                this.device = window.innerWidth < this.breakpoint ? 'mobile' : 'desktop';
            },
        },
    };
</script>

<style lang="scss">
    html {
        @apply bg-blue;
    }

    .matchmaker {
        @media (max-height: 700px) {
            &__portrait-img {
                height: 200px;
            }

            &__aldi-logo {
                height: 40px;
            }

            &__exp-logo {
                height: 70px;
            }

            @screen md {
                &__progress-bar {
                    @apply mt-14;
                }
            }
        }
    }
</style>
